import { sanitizeFilterTree, type JobFilterTree } from "@domain/CRM/job";

/** Which scheduling list a filter tree belongs to. The two lists filter independently,
 *  so each persists under its own key. */
export type SchedulingFilterPanel = "unassigned" | "shifts";

/** `unassigned` keeps the original key so trees saved before the Shifts panel existed
 *  are still read back. */
const KEY_PREFIX: Record<SchedulingFilterPanel, string> = {
	unassigned: "rogo_scheduling_filter:",
	shifts: "rogo_scheduling_shifts_filter:",
};

/**
 * Persists a Scheduling list's filter tree per user+browser, per panel. Scope key
 * mirrors the job-count store (`getImpersonatedEmail() ?? "self"`). Reads run
 * the raw JSON through `sanitizeFilterTree`, so a stale/renamed field can never
 * crash the page — the offending condition is dropped and the rest survives.
 */
export const schedulingFilterStore = {
	get(scopeKey: string, panel: SchedulingFilterPanel = "unassigned"): JobFilterTree | null {
		const raw = localStorage.getItem(KEY_PREFIX[panel] + scopeKey);
		if (raw === null) return null;
		try {
			return sanitizeFilterTree(JSON.parse(raw));
		} catch {
			return null;
		}
	},
	set(scopeKey: string, tree: JobFilterTree, panel: SchedulingFilterPanel = "unassigned"): void {
		localStorage.setItem(KEY_PREFIX[panel] + scopeKey, JSON.stringify(tree));
	},
};
